// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { TileSize, TileSizeMobile } from '../../_components/ui'

import { TeaserBoxVersion } from '../TeaserBox.contracts'
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  name: 'TeaserBoxInnerGrid1XL'
})
export class TeaserBoxInnerGrid1XL extends TeaserBoxAddonsMixin {
  public static readonly moduleVersion: TeaserBoxVersion = TeaserBoxVersion['1XL']
  public gridConfig = {
    defaultSize: TileSize.S,
    mobileSize: TileSizeMobile.TILE,
    tiles: {
      0: TileSize.XL
    },
    listOffset: 1,
    listType: false
  }
}
